import * as React from 'react'
import { useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import Card from '../../atoms/Card'
import CustomPaymentButton, {
  CustomPaymentButtonProps
} from '../CustomPaymentButton/CustomPaymentButton'
import * as S from './ExpressCheckout.styles'

const ExpressCheckout: React.FC<CustomPaymentButtonProps> = ({
  isAvailable,
  loading,
  availableMethod,
  clickHandler,
  errorMsg
}) => {
  const { t } = useTranslation()

  return isAvailable ? (
    <S.ExpressCheckoutWrapper role="article">
      <Card title={t('react_components.wallet_pay.express_checkout')}>
        <CustomPaymentButton
          isPdp={false}
          isAvailable={isAvailable}
          loading={loading}
          availableMethod={availableMethod}
          errorMsg={errorMsg}
          clickHandler={clickHandler}
        />
      </Card>
      <S.Separator>
        <S.SeparatorText as="p" variant="body">
          {t('react_components.wallet_pay.or')}
        </S.SeparatorText>
        <S.HorizontalLine />
      </S.Separator>
    </S.ExpressCheckoutWrapper>
  ) : null
}

export default withTranslations(ExpressCheckout)
